mutation PurchaseOrderApprovalCreate(
  $input: PurchaseOrderApprovalCreateInput!
) {
  purchaseOrderApprovalCreate(input: $input) {
    approvalRequestResults {
      _status
      _isSubmitted
      entityId
    }
  }
}
